/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Room_Blocked_ValvesInputs */



/**
* | output |
* | --- |
* | "The room still contains valves" |
*
* @param {Delete_Room_Blocked_ValvesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const delete_room_blocked_valves = /** @type {((inputs?: Delete_Room_Blocked_ValvesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Room_Blocked_ValvesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The room still contains valves")
	return /** @type {LocalizedString} */ ("La pièce contient encore des têtes thermostatiques")
});